import { render } from "./Page404.vue?vue&type=template&id=7b41fd12"
import script from "./Page404.vue?vue&type=script&lang=js"
export * from "./Page404.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\raubart\\Desktop\\loop\\hyundai_shop\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__